































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as config from './config';
import { detail } from './api/index';
import SyPlayer from '@/components/SyPlayer.vue';
import { Swipe, SwipeItem } from 'vant';
// import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(Swipe).use(SwipeItem);
@Component({
  components: {
    SyPlayer,
  },
})
export default class Detail extends Vue {
  option = config.OPTHINES;
  detailData: any = {};
  show: boolean = false;
  titleImage: any[] = [];
  created() {
    this.fetchDetail();
  }
  async fetchDetail() {
    const res = await detail(this.$route.query.id);
    this.detailData = res.data;
  }
}
